<template>
  <div class="wrap-index fontSpecial">
    <div class="top-bg"></div>
    <div class="bottom-bg"></div>
    <div class="content-box">
      <!-- 标题 -->
      <div class="title">
        <p>中医体质测评</p>
      </div>
      <!-- 文字区域 -->
      <div class="Text-area">
        <p>《中医体质分类与判定》标准正式发布，该标准是我国第一部指导和规范中医体质研究及应用的文件，旨在为体质辨识及与中医体质相关疾病的防治、养生保健、健康管理提供依据，使体质分类科学化、规范化。</p>
        <br />
        <p>该标准将体质分为平和质、气虚质、阳虚质、阴虚质、痰湿质、湿热质、血瘀质、气郁质、特禀质九个类型，应用了流行病学、免疫学、分子生物学、遗传学、数理统计学等多学科交叉的方法，经中医临床专家、流行病学专家、体质专家多次论证而建立的体质辨识的标准化工具。</p>
      </div>
      <!-- 底部图片 -->
      <div class="bottom">
        <button class="result" @click="ToResult"></button>
        <button class="mianfei" @click="ToStart"></button>
      </div>
    </div>
  </div>
</template>

<script>
import { getApi } from '../../api/index.js'
import {AppIdName,TokenName,jxAppId} from '../../api/api.js';

export default {
  data() {
    return {
      lifeToken: ''
    }
  },
  created: function() {
    let appId = localStorage.getItem(AppIdName);
    this.lifeToken = localStorage.getItem(TokenName+appId || "");	
    if (!this.lifeToken) {
      this.handleWx()
    }
  },
  methods: {
    handleWx() {
      let code = this.$route.query.code
      if (code && code != '') {
        this.code = code
        this.toLogin()
      } else {
        this.onCheck()
      }
    },
    toLogin() {
	  let appid = this.$route.query.appid || 'wx5e9898e74f3d23ae'
      getApi({ url: '/member/login/' + this.code+"?appId="+appid, query: {} })
        .then(res => {
          if (res && res.resCode == '0') {
            if (res.data) {
              sessionStorage.setItem('lifejk_token', res.data.accessToken)
            } else {
              this.$toast('登录失败')
            }
          } else {
            this.$toast(res.resMsg || '登录失败')
          }
        })
        .catch(res => {
          console.log('登录失败')
        })
    },
    onCheck() {
      let url = encodeURIComponent(window.location.href)
      let appid = this.$route.query.appid || 'wx5e9898e74f3d23ae'
      let weixinUrl =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        url +
        '&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'
      window.location.href = weixinUrl
    },
    ToResult() {
      this.$router.push({
        path: '/medical/resultList',
        query: {}
      })
    },
    ToStart() {
      this.$router.push({
        path: '/medical/start',
        query: {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-index {
  position: relative;
  background: url('../../assets/image/start/center-bg.png') repeat center;
  background-size: 100%;
  min-height: 100%;
  padding: 1.74rem 0 1.52rem;
  box-sizing: border-box;
  .top-bg {
    position: absolute;
    left: 0;
    top: 0;
    background: url('../../assets/image/start/no-font-top-bg.png') no-repeat top;
    background-size: 100%;
    height: 1.74rem;
    width: 100%;
    z-index: 1;
  }
  .bottom-bg {
    width: 100%;
    height: 1.52rem;
    background: url('../../assets/image/start/short-bottom-bg.png') no-repeat
      bottom;
    background-size: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .content-box {
    // position: fixed;
    // left: 0;
    // top: 0;
    // width: 100%;
    // height: 100%;
    // z-index: 10;
    width: 100%;
    text-align: center;
  }
  .title {
    text-align: center;
    font-size: 0.72rem;
    color: rgb(51, 51, 51);
  }
  .Text-area {
    display: inline-block;
    width: 5.29rem;
    height: 6.2rem;
    padding-top: 0.55rem;
    padding-bottom: 1.17rem;
    p {
	  line-height: 0.42rem;
      font-size: 0.34rem;
      text-align: left;
      text-indent: 0.5rem;      
      color: rgb(51, 51, 51);
    }
  }
  .bottom button {
    width: 2.28rem;
    height: 0.66rem;
    border-radius: 3rem;
    background-size: 100%;
    border: 0;
  }
  .result {
    margin-right: 0.38rem;
    background-image: url('../../assets/image/index/result.png');
  }
  .mianfei {
    background-image: url('../../assets/image/index/minfei.png');
  }
}
</style>
